var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.752,
    height: 49.783,
    viewBox: "0 0 44.752 49.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke:#000;stroke-width:.4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order",
    transform: "translate(-23.804 .211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(27.349 27.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M56.84 264a.836.836 0 0 0-.836.836v3.345a.836.836 0 1 0 1.673 0v-3.345a.836.836 0 0 0-.837-.836z",
    className: "cls-1",
    "data-name": "Path 25",
    transform: "translate(-56.004 -264.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(30.695 29.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M88.84 280a.836.836 0 0 0-.836.836v3.345a.836.836 0 0 0 1.673 0v-3.345a.836.836 0 0 0-.837-.836z",
    className: "cls-1",
    "data-name": "Path 26",
    transform: "translate(-88.004 -280.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(51.604 32.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M298.447 313.145a.836.836 0 0 0-.937 1.385 5.018 5.018 0 1 1-2.805-.856.836.836 0 1 0 0-1.673 6.691 6.691 0 1 0 3.742 1.143z",
    className: "cls-1",
    "data-name": "Path 27",
    transform: "translate(-288.016 -312.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(24.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M67.935 36.53a10.032 10.032 0 0 0-5.46-6.338V11.709a.836.836 0 0 0-.411-.72L43.665.117a.836.836 0 0 0-.851 0l-18.4 10.872c-.018.01-.03.025-.047.037l-.049.038a.824.824 0 0 0-.185.2c0 .006-.01.009-.013.015v.006a.836.836 0 0 0-.095.273.74.74 0 0 1-.01.074.731.731 0 0 0-.012.073v21.749a.836.836 0 0 0 .411.72l18.4 10.872a.687.687 0 0 0 .068.028.66.66 0 0 0 .07.03.746.746 0 0 0 .575 0 .674.674 0 0 0 .071-.03c.022-.01.045-.016.067-.028l4.994-2.951a10.032 10.032 0 0 0 19.276-5.565zM43.24 1.808l4.349 2.57-6.449 3.81a.837.837 0 1 0 .851 1.441l7.242-4.276 4.349 2.57-16.755 9.9-4.349-2.57 7.006-4.14a.837.837 0 0 0-.851-1.441l-7.8 4.609-4.35-2.57zM35.991 19.27v5.584l-4.32-2.554v-5.583zm12.6 17.452a10.189 10.189 0 0 0-.275 3.633l-4.237 2.5v-2.711a.836.836 0 0 0-1.673 0v2.716l-16.729-9.883v-19.8L30 15.728v7.049a.836.836 0 0 0 .411.721l5.989 3.543a.837.837 0 0 0 1.262-.72v-6.063l4.739 2.8V36.8a.836.836 0 0 0 1.673 0V23.059L59.233 14.1a.836.836 0 0 0-.851-1.44L43.24 21.61l-4.767-2.818 16.755-9.9 5.572 3.294v17.42a10 10 0 0 0-12.212 7.117zm9.705 10.949a8.363 8.363 0 1 1 8.363-8.363 8.363 8.363 0 0 1-8.366 8.363z",
    className: "cls-1",
    "data-name": "Path 28",
    transform: "translate(-24.004)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(54.958 36.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M326.517 352.335a.836.836 0 0 0-1.162 0l-3.172 3.172-.663-.663a.836.836 0 0 0-1.183 1.183l1.255 1.254a.836.836 0 0 0 1.183 0l3.763-3.763a.836.836 0 0 0-.021-1.183z",
    className: "cls-1",
    "data-name": "Path 29",
    transform: "translate(-320.102 -352.1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.b7c39376.svg";
export { ForwardRef as ReactComponent };